export const types = <const>{
	getters: {
		EXTERNAL_URL: 'EXTERNAL_URL',
	},
	actions: {
		INITIALISE_STORE: 'INITIALISE_STORE',
		INIT_EXTERNAL_MODULES: 'INIT_EXTERNAL_MODULES',
		GO_TO_EXTERNAL_ROUTE: 'GO_TO_EXTERNAL_ROUTE',
	},
	mutations: {
		INITIALISE_STORE: 'INITIALISE_STORE',
		RESET_EXTERNAL_MODULES: 'RESET_EXTERNAL_MODULES',
		SET_EXTERNAL_MODULES_PERMISSIONS: 'SET_EXTERNAL_MODULES_PERMISSIONS',
		REPLACE_EXTERNAL_CRUMBS: 'REPLACE_EXTERNAL_CRUMBS',
		SET_OPENER: 'SET_OPENER',
		REPLACE_EXTERNAL_ROUTE: 'REPLACE_EXTERNAL_ROUTE',
	},
};
